/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgNetworkAnalyticsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.875 11.025a.525.525 0 100-1.05.525.525 0 000 1.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 8.525h-5.25v-4.75l-.5-.5H.5l-.5.5v6.5l.5.5H3v1.45l.5.5h12l.5-.5v-3.2l-.5-.5zm-12.5.5v.75H1v-5.5h8.25v4.25H3.5l-.5.5zm12 2.7H4v-2.2h11v2.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.025 7.075h-1v.93h1v-.93zM5.625 5.925h-1V8.01h1V5.925zM7.225 5h-1v3.02h1V5z"
}));

export default SvgNetworkAnalyticsLogo;